import { render, staticRenderFns } from "./SubAgentTransactions.vue?vue&type=template&id=4ca30636"
import script from "./SubAgentTransactions.vue?vue&type=script&lang=js"
export * from "./SubAgentTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports